import { Button as AntButton, ButtonProps } from 'antd';
import styled, { CSSProperties, FlattenSimpleInterpolation, css } from 'styled-components';

const primaryBackgroundColor = '#fff';
const primaryBorderColor = '#686868';
const primaryColor = '#494949';
const primaryBorderRadius = '2px';

export interface IActionBaseButton extends ButtonProps {
  disabled?: boolean;
  highlight?: boolean;
  backgroundcolor?: string;
  bordercolor?: string;
  color?: string;
  borderradius?: string;
  hoverstyle?: CSSProperties;
}

const modifyHighlightColor = (
  backgroundcolor = primaryBackgroundColor,
  bordercolor = primaryBorderColor,
  color = primaryColor,
  borderradius = primaryBorderRadius,
) => {
  return css`
    background-color: ${backgroundcolor};
    border-color: ${bordercolor};
    color: ${color};
    border-radius: ${borderradius};
  `;
};

const camelToKebabCase = (str: string): string => {
  return str.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
};

const styleToInterpolation = (
  hoverStyle?: CSSProperties,
): FlattenSimpleInterpolation | undefined => {
  if (!hoverStyle) return undefined;

  const styleString = Object.keys(hoverStyle)
    .map((key) => `${camelToKebabCase(key)}: ${hoverStyle[key]};`)
    .join(' ');

  return css`
    ${styleString}
  `;
};

export const ActionBaseButton = styled(AntButton)<IActionBaseButton>`
  && {
    display: inline-flex;
    align-items: center;
    padding: 3px 7px;
    gap: 2px;
    color: #fff;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    letter-spacing: -0.01em;
    line-height: 20px;
    box-shadow: none;
    height: 28px;

    ${({ backgroundcolor, bordercolor, color, borderradius }) =>
      modifyHighlightColor(backgroundcolor, bordercolor, color, borderradius)}
    /* &:hover, */
    &:focus {
      ${({ backgroundcolor, bordercolor, color, borderradius }) =>
        modifyHighlightColor(backgroundcolor, bordercolor, color, borderradius)}
      ${({ hoverstyle }) => styleToInterpolation(hoverstyle)}
    }

    &[disabled],
    /* &[disabled]:hover, */
    &[disabled]:focus,
    &[disabled]:active {
      ${({ disabled }) => {
        if (disabled) {
          return css`
            opacity: 0.4;
          `;
        }
      }}
      ${({ backgroundcolor, bordercolor, color, borderradius }) =>
        modifyHighlightColor(backgroundcolor, bordercolor, color, borderradius)}
    }

    &[ant-click-animating-without-extra-node='true']::after {
      display: none;
    }

    & .anticon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      font-size: 16px;
    }

    & > .anticon + span,
    & > span + .anticon {
      margin-left: 0;
    }
  }
`;
